/** @format */

import {CommonChartData} from 'components/charts/multiline-chart/model/charts';
import {TooltipExtraRow} from 'components/charts/multiline-chart/model/tooltip';

import {roundFloatNumber, divideBySpaces} from 'helpers/numberHelpers';

import {FORECAST_KEYS} from 'components/charts/multiline-chart/const';

import getValueWithToken from '../../helpers/getValueWithToken';

export interface GetTooltipPointForecastOptions {
  data: CommonChartData;
  token?: string;
  hideForecast?: boolean;
  roundNumberBy: number;
}

const getTooltipPointForecast = ({
  data,
  hideForecast,
  token,
  roundNumberBy,
}: GetTooltipPointForecastOptions): TooltipExtraRow[] => {
  const {average, averageSecondary, rangeSecondary, range} = data;

  const hasForecast =
    average !== undefined ||
    averageSecondary !== undefined ||
    rangeSecondary !== undefined ||
    range !== undefined;

  // Нет прогноза на этот график в этот день

  if (hideForecast || !hasForecast) {
    return [];
  }

  const result: TooltipExtraRow[] = [];

  // Средний прогноз

  if (average !== undefined) {
    const roundedValue = roundFloatNumber(average, roundNumberBy);
    const value = divideBySpaces(roundedValue);
    const row: TooltipExtraRow = {
      label: FORECAST_KEYS.Average,
      value: {
        primary: getValueWithToken({
          value,
          token,
        }),
      },
    };

    if (averageSecondary !== undefined) {
      const roundedValue = roundFloatNumber(averageSecondary, roundNumberBy);
      const value = divideBySpaces(roundedValue);
      row.value.secondary = getValueWithToken({
        value,
        token,
      });
    }

    result.push(row);
  }

  // Минимальный и максимальный прогноз

  if (range !== undefined) {
    const roundedValueMin = roundFloatNumber(range[0], roundNumberBy);
    const valueMin = divideBySpaces(roundedValueMin);
    const roundedValueMax = roundFloatNumber(range[1], roundNumberBy);
    const valueMax = divideBySpaces(roundedValueMax);
    const rows: TooltipExtraRow[] = [
      {
        label: FORECAST_KEYS.Min,
        value: {
          primary: getValueWithToken({
            value: valueMin,
            token,
          }),
        },
      },
      {
        label: FORECAST_KEYS.Max,
        value: {
          primary: getValueWithToken({
            value: valueMax,
            token,
          }),
        },
      },
    ];

    if (rangeSecondary !== undefined) {
      const roundedValueMin = roundFloatNumber(rangeSecondary[0], roundNumberBy);
      const valueMin = divideBySpaces(roundedValueMin);
      const roundedValueMax = roundFloatNumber(rangeSecondary[1], roundNumberBy);
      const valueMax = divideBySpaces(roundedValueMax);
      rows[0].value.secondary = getValueWithToken({
        value: valueMin,
        token,
      });
      rows[1].value.secondary = getValueWithToken({
        value: valueMax,
        token,
      });
    }

    result.push(...rows);
  }

  return result;
};

export default getTooltipPointForecast;
